import React from 'react';
import { Link } from 'gatsby';

import storyItemStyle from './storyItem.module.css';
import Sound from '../../icons/Sound';

const StoryItem = (props) => (
  <article className={storyItemStyle.article}>
    <Link to={props.link} className={storyItemStyle.link}>
      <picture>
        <source srcSet={props.imageSrc.tablet} media="(min-width: 768px)" />
        <source srcSet={props.imageSrc.desktop} media="(min-width: 1440px)" />
        <img src={props.imageSrc.mobile} alt={props.name} className={storyItemStyle.image} />
      </picture>

      <div style={{ width: '100%' }}>
        <h2 className={storyItemStyle.name}>{props.name}</h2>

        <div className={storyItemStyle.bio}>{props.bio}</div>

        <p className={storyItemStyle.quote}>{props.quote}</p>

        <time className={storyItemStyle.duration}>
          {props.duration}

          <Sound />
        </time>
      </div>
    </Link>
  </article>
)

export default StoryItem;
